<template>
  <div v-if="!isDesign" class="ds_channel_list">
    <div class="wrap">
      <div class="cover">
        <el-image src="https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg"></el-image>
      </div>
      <div class="desc">
        <h3 class="desc-title">
          <span class="name">1</span>
        </h3>
        <div class="info">
          <span>15门课程</span>
          <span>15个学时</span>
        </div>
        <div class="tags">
          <span>123人参加</span>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="ds-platform-card-item-by-train" @click="click">
    <div class="channel-card-wrap">
      <div class="cover">
        <el-image src="https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg"></el-image>
      </div>
      <div class="desc">
        <h3 class="desc-title">
          <span class="name">1</span>
        </h3>
        <div class="info">
          <span>15门课程</span>
          <span>15个学时</span>
        </div>
        <div class="tags">
          <span>123人参加</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfNcChannelCard",
  ctrlCaption: "学习专区卡片",
  mixins: [$mixins.control],
  mounted() {
    if (!this.isDesign) this.loadChannelCard();
  },
  methods: {
    loadChannelList() {},
  },
});
</script>
